import loadable from '@loadable/component'

export default [
  // 币商钱包
  {
    path: '/CoinsAgency',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinsAgency" */ '~/pages/CoinsAgency/pages/wallet'
        )
    ),
  },
  // 币商充值
  {
    path: '/CoinsAgency/recharge',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinsAgency-recharge" */ '~/pages/CoinsAgency/pages/recharge'
        )
    ),
  },
  // 币商售卖
  {
    path: '/CoinsAgency/sell/:restCurrency',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinsAgency-sell" */ '~/pages/CoinsAgency/pages/sell'
        )
    ),
  },
  // 币分销管理
  {
    path: '/CoinsAgency/distributor',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinsAgency-distributor" */ '~/pages/CoinsAgency/pages/distribution'
        )
    ),
  },
  {
    path: '/coinagency/signup',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencySignup" */ '~/pages/Coinagency/Signup'
        )
    ),
  },
  // 超级币商分销页面
  {
    path: '/coinagency/DistributorManageSuper',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinagencyDistributorManageHighest" */ '~/pages/Coinagency/DistributorManageSuper'
        )
    ),
  },
]
